<template>
    <div class="notifications-container">
        <!-- Loading State -->
        <div v-if="loading" class="loading-state">
            <div class="loader-spinner"></div>
            <p>Loading notifications...</p>
        </div>

        <!-- Empty State -->
        <div v-else-if="notifications.length === 0" class="empty-state">
            <div class="empty-icon">
                <i class="nc-icon nc-bell-55"></i>
            </div>
            <h3>No Notifications</h3>
            <p>You're all caught up! Check back later for updates.</p>
        </div>

        <!-- Notifications List -->
        <div v-else class="notifications-list">
            <transition-group name="notification-item" tag="div">
                <div v-for="notification in notifications" 
                     :key="notification.id" 
                     class="notification-card">
                    <div class="notification-content">
                        <button @click="deleteNotification(notification)" 
                                class="delete-btn"
                                aria-label="Delete notification">
                            <i class="nc-icon nc-simple-remove"></i>
                        </button>
                        
                        <div class="notification-icon">
                            <i class="nc-icon nc-bell-55"></i>
                        </div>
                        
                        <div class="notification-body">
                            <h4 class="notification-title">{{ notification.title }}</h4>
                            <p class="notification-message">{{ notification.body }}</p>
                            
                            <!-- Action Buttons -->
                            <div v-if="notification.type === 'TYPE_PROJECT_INVITATION'" 
                                 class="notification-actions">
                                <button type="button" 
                                        class="action-btn btn-accept"
                                        @click="joinExtProject(notification)">
                                    <i class="nc-icon nc-check-2"></i>
                                    Accept Invitation
                                </button>
                            </div>
                            
                            <div v-if="notification.type === 'REQUEST_REASSIGN_VACCINATION_AREA'" 
                                 class="notification-actions">
                                <button type="button" 
                                        class="action-btn btn-reject"
                                        @click="respondReassign(notification, 'reject')">
                                    <i class="nc-icon nc-simple-remove"></i>
                                    Reject
                                </button>
                                <button type="button" 
                                        class="action-btn btn-accept"
                                        @click="respondReassign(notification, 'accept')">
                                    <i class="nc-icon nc-check-2"></i>
                                    Accept
                                </button>
                            </div>
                            
                            <div v-if="notification.type === 'REQUEST_REASSIGN_SURVEY_AREA'" 
                                 class="notification-actions">
                                <button type="button" 
                                        class="action-btn btn-reject"
                                        @click="respondReassignSurvey(notification, 'reject')">
                                    <i class="nc-icon nc-simple-remove"></i>
                                    Reject
                                </button>
                                <button type="button" 
                                        class="action-btn btn-accept"
                                        @click="respondReassignSurvey(notification, 'accept')">
                                    <i class="nc-icon nc-check-2"></i>
                                    Accept
                                </button>
                            </div>
                            
                            <div class="notification-time">
                                <i class="nc-icon nc-time-alarm"></i>
                                {{ activeAgo(notification.updated_at, 'UTC') }}
                            </div>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>
<script>
import VOffline from 'v-offline';

export default {

    components: {
        VOffline
    },
    data() {
        return {
            notifications: [],
            loading: true,
        }
    },
    methods: {

        init() {
            let vm = this;
            vm.loading = true;

            axios.get('user/notifications').then(response => {
                if (response.data.response.error.error_code == 0) {
                    vm.notifications = response.data.response.data.notifications;
                }
            }).catch(error => {
                console.error('Error loading notifications:', error);
            }).finally(() => {
                vm.loading = false;
            });
        },
        async respondReassign(noti, status) {
            let respondFlag;
            const {id} = noti;
            respondFlag = status === 'accept' ? 1 : 0;
            try {
                const response = await axios.post(`/notification/approve/reassignVaccinationArea/${id}/${respondFlag}`);
                this.showAlert('Success', response.data.response.error.msg, true);
                this.init();
            } catch (error) {
                this.showAlert('Failed', error.response.data.response.error.msg, false);
            }

        },
        async joinExtProject(noti) {
            let data = JSON.parse(noti.data)
            window.location.href = data.invitation_link;
        },
        async respondReassignSurvey(noti, status) {
            let respondFlag;
            const {id} = noti;
            respondFlag = status === 'accept' ? 1 : 0;
            try {
                const response = await axios.post(`/notification/approve/reassignSurveyArea/${id}/${respondFlag}`);
                this.showAlert('Success', response.data.response.error.msg, true);
                this.init();
            } catch (error) {
                this.showAlert('Failed', error.response.data.response.error.msg, false);
            }

        },
        async deleteNotification(noti) {
            const {id} = noti;
            try {
                const response = await axios.delete(`/notification/remove/${id}`);
                //this.showAlert('Success', response.data.response.error.msg, true);
                this.init();
            } catch (error) {
                this.showAlert('Failed', error.response.data.response.error.msg, false);
            }
        }

    },
    computed: {},
    mounted() {
        this.init();

        axios.put('/notification/mark/all/read').then(response => {
            if (response.data.response.error.error_code == 0) {

            } else {

            }
        });
    }

}

</script>
<style scoped>
.notifications-container {
    min-height: 400px;
    background: #f8f9fa;
}

/* Loading State */
.loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    color: #999;
}

.loader-spinner {
    border: 3px solid #f3f3f3;
    border-top: 3px solid #1e88e5;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Empty State */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    color: #999;
}

.empty-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #1e88e5;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.empty-icon i {
    font-size: 36px;
    color: white;
}

.empty-state h3 {
    margin: 0 0 12px 0;
    font-size: 20px;
    color: #333;
    font-weight: 600;
}

.empty-state p {
    margin: 0;
    font-size: 14px;
    color: #999;
}

/* Notifications List */
.notifications-list {
    padding: 0;
}

.notification-card {
    background: white;
    border-bottom: 1px solid #e8e8e8;
    transition: all 0.3s ease;
    position: relative;
}

.notification-card:hover {
    background: #f8f9fa;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.notification-card:last-child {
    border-bottom: none;
}

.notification-content {
    display: flex;
    padding: 20px;
    gap: 16px;
    position: relative;
}

.delete-btn {
    position: absolute;
    top: 16px;
    right: 16px;
    background: transparent;
    border: none;
    color: #999;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
}

.delete-btn:hover {
    background: #f5f5f5;
    color: #ff4444;
    transform: rotate(90deg);
}

.notification-icon {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #1e88e5;
    display: flex;
    align-items: center;
    justify-content: center;
}

.notification-icon i {
    font-size: 20px;
    color: white;
}

.notification-body {
    flex: 1;
    padding-right: 30px;
}

.notification-title {
    margin: 0 0 8px 0;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    line-height: 1.4;
}

.notification-message {
    margin: 0 0 12px 0;
    font-size: 14px;
    color: #666;
    line-height: 1.5;
}

.notification-time {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #999;
    margin-top: 12px;
}

.notification-time i {
    font-size: 14px;
}

/* Action Buttons */
.notification-actions {
    display: flex;
    gap: 10px;
    margin: 16px 0 8px 0;
    flex-wrap: wrap;
}

.action-btn {
    border: none;
    border-radius: 20px;
    font-size: 13px;
    padding: 8px 20px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: white;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.action-btn.btn-accept {
    background: #2a9055;
}

.action-btn.btn-accept:hover {
    background: #239046;
}

.action-btn.btn-reject {
    background: #eb6532;
}

.action-btn.btn-reject:hover {
    background: #d95a2b;
}

.action-btn i {
    font-size: 14px;
}

/* Animations */
.notification-item-enter-active,
.notification-item-leave-active {
    transition: all 0.4s ease;
}

.notification-item-enter {
    opacity: 0;
    transform: translateX(30px);
}

.notification-item-leave-to {
    opacity: 0;
    transform: translateX(-30px);
}

.notification-item-move {
    transition: transform 0.4s ease;
}

/* Responsive */
@media (max-width: 576px) {
    .notification-content {
        padding: 16px;
        gap: 12px;
    }

    .notification-icon {
        width: 36px;
        height: 36px;
    }

    .notification-icon i {
        font-size: 18px;
    }

    .notification-title {
        font-size: 14px;
    }

    .notification-message {
        font-size: 13px;
    }

    .action-btn {
        font-size: 12px;
        padding: 7px 16px;
    }

    .delete-btn {
        top: 12px;
        right: 12px;
    }
}
</style>
